export default {
  app: {
    faq: {
      faq: 'FAQ',
      pageTitle: 'FAQ - Elixír Tours',
      title: 'Často kladené dotazy',
    },
  },
};
